import { tx as tr } from './i18n';
// Silnik rysowania technicznych wizualizacji anten (SVG). Przeniesiony z
// osobnej aplikacji -- czysty generator stringow SVG (bez zaleznosci DOM),
// wiec dziala w React bez zmian. Eksportuje drawAntenna(type, params).

/**
 * Antenna SVG technical drawing engine — full rewrite.
 * All drawings use a fixed 720×490 canvas with clearly separated zones.
 * Physical dimensions are labelled; proportions are schematic (not to scale).
 */

"use strict";

const W = 720, H = 490;

const C = {
  bg:     "#0d1117",
  grid:   "#161b22",
  wire:   "#58a6ff",
  tube:   "#79c0ff",
  coax:   "#484f58",
  coaxIn: "#e3b341",
  balun:  "#f85149",
  unun:   "#f0883e",
  cap:    "#3fb950",
  gnd:    "#6e7681",
  gndFill:"#161b22",
  dim:    "#388bfd",
  dimTxt: "#8b949e",
  txt:    "#c9d1d9",
  muted:  "#484f58",
  mast:   "#6e5a3e",
  ins:    "#8b949e",
};

// ── SVG wrapper ────────────────────────────────────────────────────────────────
function svgOpen() {
  return `<svg viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg"
    style="width:100%;height:100%;display:block;background:${C.bg}">
    <defs>
      <marker id="ah" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
        <path d="M0,1 L9,5 L0,9 Z" fill="${C.dim}"/>
      </marker>
      <marker id="aht" viewBox="0 0 10 10" refX="0" refY="5" markerWidth="6" markerHeight="6" orient="auto">
        <path d="M9,1 L0,5 L9,9 Z" fill="${C.dim}"/>
      </marker>
    </defs>
    ${bgGrid()}`;
}
function svgClose(title) {
  return `<text x="${W/2}" y="${H-10}" fill="${C.muted}" font-size="11"
    text-anchor="middle" font-family="'Consolas','Courier New',monospace">${title}</text>
  </svg>`;
}

function bgGrid() {
  let g = `<rect width="${W}" height="${H}" fill="${C.bg}"/>`;
  for (let x = 0; x <= W; x += 40) g += `<line x1="${x}" y1="0" x2="${x}" y2="${H}" stroke="${C.grid}" stroke-width="1"/>`;
  for (let y = 0; y <= H; y += 40) g += `<line x1="0" y1="${y}" x2="${W}" y2="${y}" stroke="${C.grid}" stroke-width="1"/>`;
  return g;
}

// ── Primitive helpers ──────────────────────────────────────────────────────────
function tx(x, y, t, size=11, color=C.txt, anchor="middle", bold=false) {
  return `<text x="${x}" y="${y}" fill="${color}" font-size="${size}" text-anchor="${anchor}"
    font-family="'Consolas','Courier New',monospace" ${bold?"font-weight='700'":""}>${t}</text>`;
}

// Horizontal dimension line  y = line Y, tY = label Y
function hDim(x1, x2, lineY, labelY, text) {
  const mx = (x1 + x2) / 2;
  return `<line x1="${x1}" y1="${lineY}" x2="${x2}" y2="${lineY}"
      stroke="${C.dim}" stroke-width="1.2" marker-start="url(#aht)" marker-end="url(#ah)"/>
    <line x1="${x1}" y1="${lineY-5}" x2="${x1}" y2="${lineY+5}" stroke="${C.dim}" stroke-width="1"/>
    <line x1="${x2}" y1="${lineY-5}" x2="${x2}" y2="${lineY+5}" stroke="${C.dim}" stroke-width="1"/>
    ${tx(mx, labelY, text, 11, C.dimTxt)}`;
}

// Vertical dimension line  x = line X, lX = label X, anchor
function vDim(y1, y2, lineX, labelX, text, anchor="end") {
  const my = (y1 + y2) / 2;
  return `<line x1="${lineX}" y1="${y1}" x2="${lineX}" y2="${y2}"
      stroke="${C.dim}" stroke-width="1.2" marker-start="url(#aht)" marker-end="url(#ah)"/>
    <line x1="${lineX-5}" y1="${y1}" x2="${lineX+5}" y2="${y1}" stroke="${C.dim}" stroke-width="1"/>
    <line x1="${lineX-5}" y1="${y2}" x2="${lineX+5}" y2="${y2}" stroke="${C.dim}" stroke-width="1"/>
    <text x="${labelX}" y="${my+4}" fill="${C.dimTxt}" font-size="11" text-anchor="${anchor}"
      font-family="'Consolas','Courier New',monospace"
      transform="rotate(-90,${labelX},${my+4})">${text}</text>`;
}

function wire(x1, y1, x2, y2, w=3.5, color=C.wire) {
  return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${color}" stroke-width="${w}" stroke-linecap="round"/>`;
}

function insulator(cx, cy, r=6) {
  return `<ellipse cx="${cx}" cy="${cy}" rx="${r}" ry="${r*0.55}" fill="${C.bg}" stroke="${C.ins}" stroke-width="1.5"/>`;
}

function groundHatch(x1, xR, y) {
  let s = `<line x1="${x1}" y1="${y}" x2="${xR}" y2="${y}" stroke="${C.gnd}" stroke-width="2"/>`;
  for (let x = x1; x <= xR; x += 14)
    s += `<line x1="${x}" y1="${y}" x2="${x-10}" y2="${y+14}" stroke="${C.gnd}" stroke-width="1" opacity="0.5"/>`;
  return s;
}

function groundSymbol(cx, y) {
  return `<line x1="${cx}" y1="${y}" x2="${cx}" y2="${y+10}" stroke="${C.gnd}" stroke-width="2"/>
    <line x1="${cx-14}" y1="${y+10}" x2="${cx+14}" y2="${y+10}" stroke="${C.gnd}" stroke-width="2"/>
    <line x1="${cx-9}"  y1="${y+15}" x2="${cx+9}"  y2="${y+15}" stroke="${C.gnd}" stroke-width="1.5"/>
    <line x1="${cx-4}"  y1="${y+20}" x2="${cx+4}"  y2="${y+20}" stroke="${C.gnd}" stroke-width="1"/>`;
}

function coaxLine(x1, y1, x2, y2) {
  const dx = x2-x1, dy = y2-y1, len = Math.sqrt(dx*dx+dy*dy);
  return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${C.coax}" stroke-width="7" stroke-linecap="round"/>
    <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${C.coaxIn}" stroke-width="2.5" stroke-linecap="round"/>`;
}

function balunBox(cx, cy, label="BALUN 1:1", color=C.balun) {
  return `<rect x="${cx-28}" y="${cy-10}" width="56" height="20" rx="4"
      fill="${color}" opacity="0.9"/>
    ${tx(cx, cy+5, label, 9, "#fff")}`;
}

function ununBox(cx, cy, label="UNUN 49:1") {
  return balunBox(cx, cy, label, C.unun);
}

function txBox(cx, cy) {
  return `<rect x="${cx-24}" y="${cy-16}" width="48" height="30" rx="5"
      fill="#0d1117" stroke="${C.wire}" stroke-width="1.5"/>
    ${tx(cx, cy+4, "TX", 13, C.wire, "middle", true)}`;
}

function mastLine(x, yTop, yBot) {
  return `<line x1="${x}" y1="${yTop}" x2="${x}" y2="${yBot}"
    stroke="${C.mast}" stroke-width="6" stroke-linecap="round"/>`;
}

function dashed(x1,y1,x2,y2) {
  return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
    stroke="${C.muted}" stroke-width="1" stroke-dasharray="5,4" opacity="0.6"/>`;
}

// ── 1. DIPOLE ──────────────────────────────────────────────────────────────────
function drawDipole(p) {
  const { hw, arm, height } = p;

  // Layout zones (fixed pixel positions — schematic, not to scale)
  const cx     = W / 2;
  const wireY  = 175;     // the wire
  const gndY   = 415;     // ground
  const armPx  = 270;     // half-wire in pixels
  const lx = cx - armPx, rx = cx + armPx;
  const txY    = 330;

  let s = svgOpen();

  // ground
  s += groundHatch(60, W-60, gndY);
  s += tx(80, gndY+20, tr("Ziemia"), 10, C.muted, "start");

  // support ropes
  s += dashed(lx, wireY, lx, gndY);
  s += dashed(rx, wireY, rx, gndY);

  // height dim (left of drawing)
  s += vDim(wireY, gndY, 38, 18, `wys. ${height.toFixed(1)} m`);

  // wire arms
  s += wire(lx, wireY, cx - 4, wireY);
  s += wire(cx + 4, wireY, rx, wireY);

  // insulators
  s += insulator(lx, wireY);
  s += insulator(rx, wireY);

  // balun at feed point
  s += balunBox(cx, wireY);
  s += tx(cx + 34, wireY + 4, tr("Balun 1:1"), 9, C.balun, "start");

  // coax
  s += coaxLine(cx, wireY + 10, cx, txY - 16);
  s += tx(cx + 10, (wireY + txY) / 2, tr("koax 50 Ω"), 9, C.dimTxt, "start");

  // TX
  s += txBox(cx, txY);
  s += groundSymbol(cx, txY + 14);

  // arm dimension lines (above wire)
  s += hDim(lx, cx, wireY - 30, wireY - 35, `${arm.toFixed(3)} m`);
  s += hDim(cx, rx, wireY - 30, wireY - 35, `${arm.toFixed(3)} m`);
  // total
  s += hDim(lx, rx, wireY - 58, wireY - 63, tr('{0} m — całkowita długość', [hw.toFixed(3)]));

  // labels
  s += tx(lx, wireY + 22, tr("Izolator"), 9, C.ins, "middle");
  s += tx(rx, wireY + 22, tr("Izolator"), 9, C.ins, "middle");

  s += svgClose(tr('DIPOL PÓŁFALOWY — schemat techniczny (widok boczny)'));
  return s;
}

// ── 2. INVERTED-V ─────────────────────────────────────────────────────────────
function drawInvertedV(p) {
  const { hw, arm, mast_h, span } = p;

  const cx    = W / 2;
  const gndY  = 410;
  const mastTopY = 100;
  const mastPx = gndY - mastTopY;   // full mast in pixels
  const armPx  = 250;               // pixel length of each arm
  // 45° → tip ends at Y = mastTopY + armPx*sin45 = mastTopY + armPx/√2
  const tipY   = mastTopY + armPx * Math.sin(Math.PI / 4);
  const lTipX  = cx - armPx * Math.cos(Math.PI / 4);
  const rTipX  = cx + armPx * Math.cos(Math.PI / 4);

  let s = svgOpen();

  s += groundHatch(60, W - 60, gndY);

  // Guy-wire ropes (dashed)
  s += dashed(cx, mastTopY + 50, cx - 100, gndY);
  s += dashed(cx, mastTopY + 50, cx + 100, gndY);

  // mast
  s += mastLine(cx, mastTopY, gndY);

  // mast height dim (right side)
  s += vDim(mastTopY, gndY, W - 45, W - 22, `maszt ${mast_h.toFixed(1)} m`);

  // wire arms
  s += wire(cx, mastTopY, lTipX, tipY);
  s += wire(cx, mastTopY, rTipX, tipY);

  // insulators at tips
  s += insulator(lTipX, tipY);
  s += insulator(rTipX, tipY);

  // anchor ropes to ground (dashed)
  s += dashed(lTipX, tipY, lTipX - 20, gndY);
  s += dashed(rTipX, tipY, rTipX + 20, gndY);

  // balun at apex
  s += balunBox(cx, mastTopY - 12);
  s += tx(cx + 36, mastTopY - 8, tr("Balun 1:1"), 9, C.balun, "start");

  // coax down mast
  s += coaxLine(cx + 5, mastTopY + 10, cx + 5, gndY - 20);
  s += txBox(cx, gndY + 15);

  // arm length dim (along the arm)
  const midArmX = (cx + lTipX) / 2 - 14;
  const midArmY = (mastTopY + tipY) / 2 - 14;
  s += tx(midArmX, midArmY, `${arm.toFixed(3)} m`, 10, C.dimTxt, "end");

  // span dim (horizontal, near ground)
  s += hDim(lTipX, rTipX, gndY - 28, gndY - 33, `rozstaw kotew ${span.toFixed(2)} m`);

  // angle annotation
  s += `<path d="M ${cx} ${mastTopY+40} A 40 40 0 0 1 ${cx - 40*Math.cos(Math.PI/4)} ${mastTopY + 40 + 40*Math.sin(Math.PI/4)}"
    fill="none" stroke="${C.dimTxt}" stroke-width="1" stroke-dasharray="3,2"/>`;
  s += tx(cx - 48, mastTopY + 58, "45°", 10, C.dimTxt, "end");

  s += tx(lTipX - 4, tipY + 20, tr("Izolator"), 9, C.ins, "end");
  s += tx(rTipX + 4, tipY + 20, tr("Izolator"), 9, C.ins, "start");

  s += svgClose("DIPOL INVERTED-V — schemat techniczny (widok boczny)");
  return s;
}

// ── 3. EFHW ───────────────────────────────────────────────────────────────────
function drawEFHW(p) {
  const { hw, height } = p;

  const x0    = 80;   // feed/UNUN end
  const x1    = W - 70; // far end
  const wireY = 155;
  const gndY  = 415;

  let s = svgOpen();

  s += groundHatch(50, W - 50, gndY);

  // Support poles (schematic)
  s += mastLine(x0, wireY - 10, gndY);
  s += mastLine(x1, wireY - 10, gndY);

  // Wire
  s += wire(x0, wireY, x1, wireY);
  s += insulator(x1, wireY);

  // UNUN at feed end
  s += ununBox(x0, wireY + 24);
  s += tx(x0 + 36, wireY + 28, "UNUN 49:1", 9, C.unun, "start");

  // Coax from UNUN down
  s += coaxLine(x0, wireY + 34, x0, 310);
  s += tx(x0 + 10, 230, tr("koax 50 Ω"), 9, C.dimTxt, "start");
  s += txBox(x0, 322);
  s += groundSymbol(x0, 336);

  // Height dim (left)
  s += vDim(wireY, gndY, 34, 14, `wys. ${height.toFixed(1)} m`);

  // Wire length dim (above)
  s += hDim(x0, x1, wireY - 30, wireY - 35, `${hw.toFixed(3)} m — drut antenowy`);

  // Impedance callout at far end
  s += tx(x1 - 5, wireY - 12, tr("Koniec wolny"), 9, C.ins, "end");
  s += tx(x1 - 5, wireY - 24, `Imp. ≈ 2450 Ω`, 9, C.dimTxt, "end");

  // Feed impedance callout
  s += tx(x0 + 36, wireY + 44, tr("Imp. wej. → 50 Ω"), 9, C.dimTxt, "start");

  s += svgClose("EFHW (End-Fed Half-Wave) — schemat techniczny (widok boczny)");
  return s;
}

// ── 4. GROUND PLANE (VERTICAL) ────────────────────────────────────────────────
function drawVertical(p) {
  const { qw, n_radials } = p;

  const cx    = W / 2;
  const gndY  = 340;
  const elPx  = 220;   // vertical element height in pixels
  const topY  = gndY - elPx;
  const radPx = 190;   // radial length in pixels (schematic)
  const nr    = Math.min(n_radials, 8);

  let s = svgOpen();

  // Ground fill
  s += groundHatch(50, W - 50, gndY);
  s += `<rect x="50" y="${gndY}" width="${W-100}" height="60" fill="${C.gndFill}" opacity="0.5"/>`;
  s += tx(cx, gndY + 30, `radiale zakopane ~5 cm  (×${nr} szt.)`, 10, C.muted, "middle");

  // Radials — draw 4 visible above ground, rest below (dashed)
  const angles = [];
  for (let i = 0; i < nr; i++) angles.push((i * Math.PI) / (nr / 2));

  for (let i = 0; i < angles.length; i++) {
    const angle = angles[i];
    const ex = cx + radPx * Math.cos(angle);
    const ey = gndY + radPx * 0.3 * Math.sin(angle);
    const aboveGnd = ey <= gndY;
    if (aboveGnd) {
      s += wire(cx, gndY, ex, ey, 2.5, C.wire);
    } else {
      s += `<line x1="${cx}" y1="${gndY}" x2="${ex}" y2="${ey}"
        stroke="${C.wire}" stroke-width="2" stroke-dasharray="5,3" opacity="0.5"/>`;
    }
  }

  // Vertical element (tube)
  s += `<rect x="${cx-4}" y="${topY}" width="8" height="${elPx}" rx="3"
    fill="${C.tube}" opacity="0.9"/>`;

  // Cap at top
  s += `<ellipse cx="${cx}" cy="${topY}" rx="10" ry="5" fill="${C.tube}"/>`;

  // Feed point
  s += `<circle cx="${cx}" cy="${gndY}" r="8" fill="${C.bg}" stroke="${C.wire}" stroke-width="2"/>`;

  // Coax from feed
  s += coaxLine(cx + 12, gndY, cx + 12, gndY + 65);
  s += txBox(cx + 12, gndY + 78);

  // Element height dim (right)
  s += vDim(topY, gndY, cx + 50, cx + 70, `${qw.toFixed(3)} m`);

  // Radial length dim
  s += hDim(cx, cx + radPx * Math.cos(0), gndY + 80, gndY + 85, `${qw.toFixed(3)} m (radiale)`);

  s += tx(cx, topY - 18, tr("Szczyt elementu λ/4"), 10, C.dimTxt, "middle");
  s += tx(cx - 16, gndY - 8, tr("Punk zasilania"), 9, C.ins, "end");

  s += svgClose(tr('PIONOWA ĆWIERĆFALOWA (GROUND PLANE) — schemat techniczny (widok boczny)'));
  return s;
}

// ── 5. MAG LOOP ───────────────────────────────────────────────────────────────
function drawMagLoop(p) {
  const { diam, circ } = p;

  const cx = W / 2, cy = 220;
  const R  = 145;          // main loop radius in pixels
  const Rc = R * 0.2;      // coupling loop radius

  let s = svgOpen();

  // Main loop — copper tube
  s += `<circle cx="${cx}" cy="${cy}" r="${R}" fill="none" stroke="${C.tube}" stroke-width="9"/>`;

  // Gap at top (capacitor)
  const gapHalf = 18;
  s += `<rect x="${cx - gapHalf - 2}" y="${cy - R - 14}" width="${gapHalf*2 + 4}" height="28"
    fill="${C.bg}"/>`;
  // Capacitor plates
  s += `<rect x="${cx - gapHalf - 1}" y="${cy-R-10}" width="${gapHalf-2}" height="18" rx="2"
    fill="${C.cap}" opacity="0.9"/>`;
  s += `<rect x="${cx + 3}" y="${cy-R-10}" width="${gapHalf-2}" height="18" rx="2"
    fill="${C.cap}" opacity="0.9"/>`;
  s += tx(cx, cy - R - 22, tr("Kondensator strojący"), 10, C.cap, "middle");

  // Coupling loop
  s += `<circle cx="${cx}" cy="${cy + R*0.5}" r="${Rc}" fill="none" stroke="${C.wire}" stroke-width="2.5"/>`;
  s += tx(cx, cy + R*0.5 + Rc + 16, tr("Pętla sprzęgająca (~20%)"), 9, C.dimTxt, "middle");

  // Coax from coupling loop
  s += coaxLine(cx, cy + R*0.5 + Rc, cx, cy + R + 20);
  s += txBox(cx, cy + R + 35);

  // Diameter dimension
  s += hDim(cx - R, cx + R, cy + R + 70, cy + R + 75, `Ø ${diam.toFixed(3)} m`);
  s += vDim(cy - R, cy + R, cx + R + 30, cx + R + 52, `Ø ${diam.toFixed(3)} m`, "start");

  // Circumference annotation
  s += tx(cx - R - 10, cy, `Obwód: ${circ.toFixed(3)} m`, 10, C.dimTxt, "end");
  s += tx(cx - R - 10, cy + 16, `(~8% λ)`, 10, C.muted, "end");

  // Material annotation
  s += tx(cx + R + 14, cy - 20, tr("Rura Cu/Al"), 9, C.dimTxt, "start");
  s += tx(cx + R + 14, cy - 6, tr("Ø 22 mm"), 9, C.dimTxt, "start");

  s += svgClose(tr('PĘTLA MAGNETYCZNA (MAG LOOP) — schemat techniczny (widok z przodu)'));
  return s;
}

// ── 6. DELTA LOOP ─────────────────────────────────────────────────────────────
function drawDeltaLoop(p) {
  const { perim, side, h_tri } = p;

  const cx   = W / 2;
  const gndY = 430;
  const hPx  = 310;  // triangle height in pixels
  const sPx  = 310;  // base width in pixels

  const tx0 = cx;          // apex X
  const ty0 = gndY - hPx;  // apex Y
  const lx  = cx - sPx/2;  // bottom-left
  const rx  = cx + sPx/2;  // bottom-right

  let s = svgOpen();

  s += groundHatch(60, W - 60, gndY);

  // Mast to apex (dashed — just shows support point)
  s += dashed(tx0, ty0, tx0, gndY);

  // Triangle wires
  s += wire(tx0, ty0, lx, gndY - 2);
  s += wire(tx0, ty0, rx, gndY - 2);
  s += wire(lx, gndY - 2, rx, gndY - 2);

  // Insulators
  s += insulator(tx0, ty0);
  s += insulator(rx, gndY - 2);

  // Feed point at bottom-left corner
  s += `<circle cx="${lx}" cy="${gndY-2}" r="9" fill="${C.bg}" stroke="${C.balun}" stroke-width="2.5"/>`;
  s += balunBox(lx - 38, gndY + 22, "λ/4 75 Ω");
  s += coaxLine(lx - 38, gndY + 33, lx - 38, gndY + 80);
  s += txBox(lx - 38, gndY + 92);

  // Dim: height of triangle
  s += vDim(ty0, gndY - 2, rx + 35, rx + 57, `${h_tri.toFixed(3)} m`);

  // Dim: base
  s += hDim(lx, rx, gndY + 18, gndY + 23, tr('{0} m (bok)  obwód: {1} m', [side.toFixed(3), perim.toFixed(3)]));

  // Side length label on left arm
  const midAX = (tx0 + lx) / 2;
  const midAY = (ty0 + gndY) / 2;
  s += tx(midAX - 20, midAY, `${side.toFixed(3)} m`, 10, C.dimTxt, "end");

  s += tx(tx0 + 10, ty0 + 14, tr("Izolator / maszt"), 9, C.ins, "start");
  s += tx(lx - 12, gndY - 14, tr("Zasilanie (λ/4 koax 75 Ω)"), 9, C.balun, "end");

  s += svgClose(tr('DELTA LOOP PEŁNOFALOWA — schemat techniczny (widok boczny)'));
  return s;
}

// ── 7. YAGI 3-ELEMENT ─────────────────────────────────────────────────────────
function drawYagi3(p) {
  const { el_de, el_refl, el_dir, sp_r_de, sp_de_d, boom } = p;

  // Plan view (top-down), boom horizontal, elements vertical
  const boomY  = H / 2;       // boom centre line
  const boomX0 = 90;
  const boomX1 = W - 60;
  const boomPx = boomX1 - boomX0;

  // Positions along boom (normalised)
  const sp1Px = (sp_r_de / boom) * boomPx;
  const sp2Px = (sp_de_d / boom) * boomPx;
  const xRefl = boomX0;
  const xDE   = boomX0 + sp1Px;
  const xDir  = boomX0 + sp1Px + sp2Px;

  // Element half-lengths in pixels (scale to longest element)
  const maxEl = Math.max(el_refl, el_de, el_dir);
  const elScale = Math.min(160, (H / 2 - 80) / maxEl * maxEl);  // max half=160px
  const halfRefl = (el_refl / maxEl) * elScale;
  const halfDE   = (el_de   / maxEl) * elScale;
  const halfDir  = (el_dir  / maxEl) * elScale;

  let s = svgOpen();

  // Boom
  s += `<rect x="${boomX0-8}" y="${boomY-5}" width="${boomPx+16}" height="10" rx="3"
    fill="${C.mast}" opacity="0.85"/>`;

  // Reflector
  s += wire(xRefl, boomY - halfRefl, xRefl, boomY + halfRefl, 5, C.muted);
  s += tx(xRefl, boomY - halfRefl - 14, tr("Reflektor"), 10, C.muted, "middle");
  s += tx(xRefl, boomY + halfRefl + 18, `${el_refl.toFixed(3)} m`, 10, C.dimTxt, "middle");
  s += vDim(boomY - halfRefl, boomY + halfRefl, xRefl - 28, xRefl - 46, `${el_refl.toFixed(3)} m`);

  // Driven element (split in centre)
  s += wire(xDE, boomY - halfDE, xDE, boomY - 6, 5, C.wire);
  s += wire(xDE, boomY + 6, xDE, boomY + halfDE, 5, C.wire);
  s += `<circle cx="${xDE}" cy="${boomY}" r="8" fill="${C.balun}" opacity="0.9"/>`;
  s += tx(xDE, boomY - halfDE - 14, tr("El. napędowy"), 10, C.wire, "middle");
  s += tx(xDE, boomY + halfDE + 18, `${el_de.toFixed(3)} m`, 10, C.dimTxt, "middle");
  s += vDim(boomY - halfDE, boomY + halfDE, xDE + 22, xDE + 40, `${el_de.toFixed(3)} m`, "start");

  // Gamma match (schematic)
  s += `<rect x="${xDE+5}" y="${boomY-22}" width="18" height="10" rx="2"
    fill="${C.unun}" opacity="0.85"/>`;
  s += tx(xDE + 14, boomY - 14, "γ", 10, "#000", "middle");

  // Coax from gamma match
  s += coaxLine(xDE + 14, boomY - 12, xDE + 14, boomY + halfDE + 50);
  s += txBox(xDE + 14, boomY + halfDE + 65);

  // Director
  s += wire(xDir, boomY - halfDir, xDir, boomY + halfDir, 5, C.tube);
  s += tx(xDir, boomY - halfDir - 14, tr("Direktor"), 10, C.tube, "middle");
  s += tx(xDir, boomY + halfDir + 18, `${el_dir.toFixed(3)} m`, 10, C.dimTxt, "middle");
  s += vDim(boomY - halfDir, boomY + halfDir, xDir + 28, xDir + 46, `${el_dir.toFixed(3)} m`, "start");

  // Spacing dims below boom
  s += hDim(xRefl, xDE, boomY + halfRefl + 40, boomY + halfRefl + 45, `${sp_r_de.toFixed(3)} m`);
  s += hDim(xDE,   xDir, boomY + halfDE + 40, boomY + halfDE + 45, `${sp_de_d.toFixed(3)} m`);

  // Boom length dim above
  s += hDim(xRefl, xDir, boomY - halfRefl - 40, boomY - halfRefl - 45, `boom: ${boom.toFixed(3)} m`);

  // Direction arrow
  s += `<polygon points="${boomX1+15},${boomY} ${boomX1},${boomY-10} ${boomX1},${boomY+10}"
    fill="${C.wire}" opacity="0.8"/>`;
  s += tx(boomX1 + 20, boomY + 4, "MAX", 10, C.wire, "start");

  s += svgClose(tr('YAGI 3-ELEMENTOWY — schemat techniczny (rzut z góry / plan)'));
  return s;
}

// ── 8. J-POLE ─────────────────────────────────────────────────────────────────
function drawJPole(p) {
  const { j_main, j_match, j_total } = p;
  const j_tap = p.j_tap || j_match * 0.09;

  const cx      = W / 2;
  const gndY    = 420;
  const totalPx = 340;                                    // cala dluzsza rura
  const matchPx = Math.round(totalPx * (j_match / j_total));
  const pipeGap = 26;
  const pipeW   = 8;
  const xMain   = cx + pipeGap / 2;
  const xMatch  = cx - pipeGap / 2;
  const mainTopY  = gndY - totalPx;
  const matchTopY = gndY - matchPx;
  const feedY   = gndY - Math.max(14, Math.round(matchPx * (j_tap / j_match)));

  let s = svgOpen();

  s += groundHatch(100, W - 100, gndY + 8);

  // Dluzsza rura: λ/4 (obok sekcji) + λ/2 (promiennik)
  s += `<rect x="${xMain - pipeW/2}" y="${mainTopY}" width="${pipeW}" height="${totalPx}"
    rx="${pipeW/2}" fill="${C.tube}" opacity="0.9"/>`;
  // Krotsza rura -- sekcja dopasowujaca λ/4
  s += `<rect x="${xMatch - pipeW/2}" y="${matchTopY}" width="${pipeW}" height="${matchPx}"
    rx="${pipeW/2}" fill="${C.tube}" opacity="0.9"/>`;
  // Zwarcie na dole
  s += `<rect x="${xMatch - pipeW/2}" y="${gndY - pipeW}" width="${pipeGap + pipeW}" height="${pipeW}"
    rx="3" fill="${C.tube}" opacity="0.9"/>`;

  // Odczep zasilania (miedzy rurami)
  s += `<circle cx="${xMatch}" cy="${feedY}" r="5" fill="${C.wire}"/>`;
  s += `<circle cx="${xMain}" cy="${feedY}" r="5" fill="${C.wire}"/>`;
  s += coaxLine(xMatch - 5, feedY, xMatch - 60, feedY);
  s += coaxLine(xMatch - 60, feedY, xMatch - 60, gndY + 40);
  s += txBox(xMatch - 60, gndY + 54);

  // Wymiary
  s += vDim(mainTopY, matchTopY, xMain + 30, xMain + 50, `${j_main.toFixed(3)} m (λ/2)`, "start");
  s += vDim(mainTopY, gndY, xMain + 80, xMain + 100, tr('{0} m (całość)', [j_total.toFixed(3)]), "start");
  s += vDim(matchTopY, gndY, xMatch - 100, xMatch - 120, `${j_match.toFixed(3)} m (λ/4)`);
  s += tx(xMatch - 70, feedY - 10, `odczep ~${(j_tap * 100).toFixed(1)} cm`, 9, C.wire, "end");
  s += hDim(xMatch, xMain, matchTopY - 18, matchTopY - 24, `25 mm`);

  s += tx(xMain + 12, mainTopY - 10, tr("Promiennik (λ/2)"), 10, C.tube, "start");
  s += tx(xMatch - 12, matchTopY - 36, tr("Sekcja dopasowania (λ/4)"), 10, C.tube, "end");
  s += tx(xMatch - 70, feedY + 6, tr("(przesuń na min. SWR)"), 8, C.muted, "end");

  s += svgClose("J-POLE (J-ANTENA) — schemat techniczny (widok z przodu)");
  return s;
}

// ── OCF DIPOLE (Windom) ─────────────────────────────────────────────────────────
function drawOCFD(p) {
  const { hw, feed_pos, height } = p;

  const cx     = W / 2;
  const wireY  = 175;
  const gndY   = 415;
  const armPx  = 270;
  // Punkt zasilania NIE jest w srodku -- przesuniety proporcjonalnie do feed_pos/hw
  const feedFrac = Math.max(0.08, Math.min(0.92, feed_pos / hw));
  const feedX  = cx - armPx + (armPx * 2) * feedFrac;
  const lx = cx - armPx, rx = cx + armPx;
  const txY    = 330;

  let s = svgOpen();
  s += groundHatch(60, W-60, gndY);
  s += tx(80, gndY+20, tr("Ziemia"), 10, C.muted, "start");
  s += dashed(lx, wireY, lx, gndY);
  s += dashed(rx, wireY, rx, gndY);
  s += vDim(wireY, gndY, 38, 18, `wys. ${height.toFixed(1)} m`);

  s += wire(lx, wireY, feedX - 4, wireY);
  s += wire(feedX + 4, wireY, rx, wireY);
  s += insulator(lx, wireY);
  s += insulator(rx, wireY);

  s += balunBox(feedX, wireY, "BALUN 4:1");
  s += coaxLine(feedX, wireY + 10, feedX, txY - 16);
  s += tx(feedX + 34, wireY + 4, tr("Balun 4:1"), 9, C.balun, "start");

  s += txBox(feedX, txY);
  s += groundSymbol(feedX, txY + 14);

  s += hDim(lx, feedX, wireY - 30, wireY - 35, tr('{0} m (krótsze)', [feed_pos.toFixed(3)]));
  s += hDim(feedX, rx, wireY - 30, wireY - 35, tr('{0} m (dłuższe)', [(hw - feed_pos).toFixed(3)]));
  s += hDim(lx, rx, wireY - 58, wireY - 63, tr('{0} m — całkowita długość', [hw.toFixed(3)]));

  s += svgClose("OCF DIPOL (WINDOM) — schemat techniczny (widok boczny)");
  return s;
}

// ── EXTENDED DOUBLE ZEPP ─────────────────────────────────────────────────────────
function drawEDZ(p) {
  const { total, arm, height } = p;

  const cx     = W / 2;
  const wireY  = 175;
  const gndY   = 415;
  const armPx  = 300;
  const lx = cx - armPx, rx = cx + armPx;
  const txY    = 330;

  let s = svgOpen();
  s += groundHatch(40, W-40, gndY);
  s += tx(60, gndY+20, tr("Ziemia"), 10, C.muted, "start");
  s += dashed(lx, wireY, lx, gndY);
  s += dashed(rx, wireY, rx, gndY);
  s += vDim(wireY, gndY, 22, 12, `wys. ${height.toFixed(1)} m`);

  s += wire(lx, wireY, cx - 4, wireY);
  s += wire(cx + 4, wireY, rx, wireY);
  s += insulator(lx, wireY);
  s += insulator(rx, wireY);

  // Zasilanie linia dwuprzewodowa (dwie rownolegle linie zamiast koax)
  s += `<line x1="${cx-3}" y1="${wireY+8}" x2="${cx-3}" y2="${txY-16}" stroke="${C.wire}" stroke-width="2"/>
        <line x1="${cx+3}" y1="${wireY+8}" x2="${cx+3}" y2="${txY-16}" stroke="${C.wire}" stroke-width="2"/>`;
  s += tx(cx + 14, (wireY + txY) / 2, tr("linia 450 Ω"), 9, C.dimTxt, "start");

  s += txBox(cx, txY);
  s += tx(cx, txY + 30, "+ TUNER", 10, C.unun, "middle", true);

  s += hDim(lx, cx, wireY - 30, wireY - 35, `${arm.toFixed(3)} m`);
  s += hDim(cx, rx, wireY - 30, wireY - 35, `${arm.toFixed(3)} m`);
  s += hDim(lx, rx, wireY - 58, wireY - 63, tr('{0} m — całkowita (1.25 λ, ramię 0.625 λ)', [total.toFixed(3)]));

  s += svgClose("EXTENDED DOUBLE ZEPP — schemat techniczny (widok boczny)");
  return s;
}

// ── Dispatcher ─────────────────────────────────────────────────────────────────
const DRAW_FN = {
  dipole:     drawDipole,
  inverted_v: drawInvertedV,
  efhw:       drawEFHW,
  vertical:   drawVertical,
  magloop:    drawMagLoop,
  delta_loop: drawDeltaLoop,
  yagi3:      drawYagi3,
  jpole:      drawJPole,
  ocfd:       drawOCFD,
  edz:        drawEDZ,
};

function drawAntenna(type, params) {
  const fn = DRAW_FN[type];
  if (!fn) {
    return `<svg viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg"
      style="width:100%;height:100%;background:#0d1117">
      <text x="${W/2}" y="${H/2}" fill="#484f58" font-size="14" text-anchor="middle">
        Brak wizualizacji dla: ${type}
      </text></svg>`;
  }
  return fn(params);
}

export { drawAntenna };
